export default "__VITE_ASSET__Cvtpi68M__"